import '../../css/common.css'
import Timeline from '../widgets/timeline/timeline';
import Youtube from '../widgets/youtube/youtube';
import linkedin_logo from '../../img/linkedin.png';
import Jobliner from '../widgets/jobliner/jobliner';
import pdf_logo from '../../img/pdf.png';
import cv_file_es from '../../files/2026-06-CV-en.pdf';
import cv_file_en from '../../files/2026-06-CV-en.pdf';
import cs_logo from '../../img/celerita.jpg';
import vtr_logo from '../../img/VTR.png';
import dawn from '../../img/dawn.png';
import webops from '../../img/webops.png';
import lla_logo from '../../img/lla-logo.png';
import claro_logo from '../../img/claro.png';
import cordada_logo from '../../img/cordada.png'
import claro_box_tv from '../../img/claro_box_tv.png'
import pixdragon_logo from '../../img/pixdragon-nowings.png'
import elch_logo from '../../img/elch-logo.png'

let inicio_es = ( <div>
    Hola, soy <strong>Alfredo Cofré</strong>, ingeniero chileno. Soy <strong>ingeniero de software</strong> titulado como <strong>Ingeniero Civil en Computación en Informática de la Universidad de Chile</strong>.
   </div>);
let inicio_en = (
    <div>
    Hi, I'm <strong>Alfredo Cofré</strong>, chilean <strong>software engineer</strong> doing telecommunications since 2010.
   </div>
)

let inicio = inicio_es;

let cv_es = (<div>
    Puedes descargar mi CV <a href={cv_file_es} target="_blank" rel="noreferrer">desde acá <img src={pdf_logo} width="32px" alt="CV"/></a>. 
    También puedes <a href="https://www.linkedin.com/in/acofre/" target="_blank" rel="noreferrer">visitar mi linkedin <img src={linkedin_logo} width="32px" alt="linked.in"/></a>.
</div>);

let cv_en = (<div>
    You can get my resume here: <a href={cv_file_en} target="_blank" rel="noreferrer"><img src={pdf_logo} width="32px" alt="Resume"/></a>. 
    Also you could <a href="https://www.linkedin.com/in/acofre/" target="_blank" rel="noreferrer">visit my linkedin <img src={linkedin_logo} width="32px" alt="linked.in"/></a>.
</div>);

let skills_es = (<div>
    Tengo más de 20 años de experiencia en el desarrollo, administración e implementación de proyectos de software y telecomunicaciones.
</div>);

let skills_en = (<div>
    I have more than 20 years of experience in the development, administration and implementation of software and telecommunications projects.
</div>);

let cordada_text_es = (<div>
    Administré la infraestructura virtual e hice SRE en Cordada, mejorando enormemente la capacidad de respuesta de la empresa ante incidentes técnicos. 
</div>);

let cordada_text_en = (<div>
    I managed the virtual infrastructure and implemented SRE strategies at Cordada, greatly improving the company's technical incident response capabilities.
</div>);

let cs_text_es =(<div>
    Lideré el desarrollo de varias apps que estuvieron disponibles en tiendas de Apple y Blackberry. Creé apps de venta móvil cliente/servidor con metalenguaje personalizado. 
</div>);

let cs_text_en =(<div>
    I led the development of several apps that were available in the Blackberry and Apple stores. I created mobile selling client/server apps with custom metalanguage.
</div>);

let vtr_text_movil_es=(<div>
    Fui parte del equipo fundador de Ingeniería Móvil de VTR Móvil.
</div>);

let vtr_text_movil_en=(<div>
    I was part of the founding Mobile Engineering Team of VTR Móvil.
</div>);

let vtr_text_dawn_es=(<div>
    Creamos in house el primer CPE de TV (d-box) híbrido (D-Box/Cablemodem) con UI moderna y capacidades de NDVR, VOD, remiders, perfiles de usuario, recomendaciones, búsqueda, catchup y replay. Yo era el hacker oficial de esa cosa.
</div>);

let vtr_text_dawn_en=(<div>
    We created the first in house developed TV hybrid CPE (d-box/cablemodem) with modern UI and VOD, NDVR, reminders, profiles, recommendations, search, catchup and replay capabilities. I was the official hacker of that thing.
</div>);

let vtr_text_eos_es=(<div>
    Desplegamos el CPE comercial D-Box 4K de Chile.
</div>);

let vtr_text_eos_en=(<div>
    We put on the market the first commercial 4K D-Box CPE in Chile.
</div>);

let vtr_text_hubtv_es=(<div>
    Levantamos el IPTV de TiVo en VTR.
</div>);

let vtr_text_hubtv_en=(<div>
    We deployed the TiVo IPTV on VTR.
</div>);

let vtr_text_webops_es=(<div>
    Creé el sistema de administración y troubleshooting de IPTV de VTR/LLA/ClaroVTR.
</div>);

let vtr_text_webops_en=(<div>
    I developed the administration and troubleshooting VTR/LLA/ClaroVTR IPTV system.
</div>);

let lla_text_es=(<div>
    Levantamos sistemas IPTV en Puerto Rico, Costa Rica, Panamá, Granada y Trinidad y Tobago.
</div>);

let lla_text_en=(<div>
    We created IPTV systems on Puerto Rico, Costa Rica, Panamá, Grenada and Trinidad & Tobago.
</div>);

let claro_text_es=(<div>
    Entregamos el nuevo servicio BoxTV de Claro Chile.
</div>);

let claro_text_en=(<div>
    We delivered the new BoxTV Claro Chile service.
</div>);

let elch_text_en=(<div>
    We developed the Energías Limpias Chile tasks and collections control system.
</div>);

let elch_text_es=(<div>
    Desarrollamos el sistema de control de tareas y cobranzas de Energías Limpias Chile.
</div>);


let cs_style = ({backgroundColor: '#f78f1e'});
let vtr_style_movil = ({backgroundColor: '#F170A9'});
let vtr_style_dawn = ({backgroundColor: 'black'});
let vtr_style_hubtv = ({backgroundColor: 'white'});
let vtr_style_eos = ({backgroundColor: 'orange'});
let vtr_style_webops = ({backgroundColor: 'teal'});
let lla_style = ({backgroundColor: 'seashell'});
let claro_style = ({backgroundColor: 'silver'});
let cordada_style = ({backgroundColor: '#010101'});
let pixdragon_style = ({backgroundColor: 'white'});


let cv = cv_es;

let skills = skills_es;
let cs_text = cs_text_es;
let vtr_text_movil = vtr_text_movil_es;
let vtr_text_dawn = vtr_text_dawn_es;
let vtr_text_eos = vtr_text_eos_es;
let vtr_text_hubtv = vtr_text_hubtv_es;
let vtr_text_webops = vtr_text_webops_es;
let lla_text = lla_text_es;
let claro_text = claro_text_es;
let cordada_text = cordada_text_es;
let elch_text = elch_text_es;


export function Work(props){

    const lang = props.lang;

    switch(lang){
        case "en":
            inicio = inicio_en;
            cv = cv_en;
            cs_text = cs_text_en;
            skills = skills_en;
            vtr_text_movil = vtr_text_movil_en;
            vtr_text_dawn = vtr_text_dawn_en;
            vtr_text_eos = vtr_text_eos_en;
            vtr_text_hubtv = vtr_text_hubtv_en;
            vtr_text_webops = vtr_text_webops_en;
            lla_text = lla_text_en;
            claro_text = claro_text_en;
            cordada_text = cordada_text_en;
            elch_text = elch_text_en;
            break;
        case "es":
        default:
            inicio = inicio_es;
            cv = cv_es;
            cs_text = cs_text_es;
            skills = skills_es;
            vtr_text_movil = vtr_text_movil_es;
            vtr_text_dawn = vtr_text_dawn_es;
            vtr_text_eos = vtr_text_eos_es;
            vtr_text_hubtv = vtr_text_hubtv_es;
            vtr_text_webops = vtr_text_webops_es;
            lla_text = lla_text_es;
            claro_text = claro_text_es;
            cordada_text = cordada_text_es;
            elch_text = elch_text_es;
            break;
    }

     


    let text_structure = (
        <div>
            <p>{inicio}</p>
            <div className='bigDiv'><article name='inicio' className='.timelineDiv'><Timeline/></article></div>
            <p>{cv}</p>
            <article name='skills'>{skills}
            <br/>
            <Jobliner logo={cs_logo} style={cs_style} text={cs_text} />
            <p></p>
            <Jobliner logo={vtr_logo} style={vtr_style_movil} text={vtr_text_movil} />
            <p></p>
            <Youtube video="https://www.youtube.com/embed/kaQjvt7p0pE?si=9upFsb4b3iN6gcyS" title="¿O es muy tonto lo que estou diciendo?"/>
            <br/>
            <Jobliner logo={vtr_logo} style={vtr_style_dawn} text={vtr_text_dawn} />
            <p></p>
            <center><a href="https://www.facebook.com/watch/?v=1321057411296159" target="_blank" rel="noreferrer"><img src={dawn} width="256" alt="Dawn STB"/><br/> On Facebook! Nuevo d-BOX PRO | VTR</a></center>
            <br/>
            <Jobliner logo={vtr_logo} style={vtr_style_eos} text={vtr_text_eos} link="https://ohmygeek.net/2017/04/10/eos-vtr-netflix-4k-deco/" />
            <p></p>
            <center><a href="https://ohmygeek.net/2017/04/10/eos-vtr-netflix-4k-deco/" target="_blank" rel="noreferrer">On the news! EOS: el nuevo nuevo decodificador de TV que tendrá VTR con Netflix y calidad 4K</a></center>
            <br/>
            <Jobliner logo={vtr_logo} style={vtr_style_hubtv} text={vtr_text_hubtv} />
            <p></p>
            <Youtube video="https://www.youtube.com/embed/qgn8op29Fr4?si=90mVOAo8Kmu0K7eB"  title="d-Box Smart de VTR"/>
            <br/>
            <Jobliner logo={vtr_logo} style={vtr_style_webops} text={vtr_text_webops} />
            <p></p>
            <center><a href="https://webops.clbo-hubtv.com/" target="_blank" rel="noreferrer"><img src={webops} width="256" alt="WebOps"/><br/>Hub TV Web Operations Center</a></center>
            <br/>
            <Jobliner logo={lla_logo} style={lla_style} text={lla_text} />
            <p></p>
            <Youtube video="https://www.youtube.com/embed/HKOAl_NnXfI?si=ss6_PxUy-QllL2yE"  title="Liberty lanza HUB TV su nueva caja inteligente con Tivo"/>
            <p></p>
            <Youtube video="https://www.youtube.com/embed/ra78z7ZZ6vM?si=7iujFqIR9TkutKfZ"  title="Conocé tu control remoto | Liberty Costa Rica"/>
            <br/>
            <Jobliner logo={claro_logo} style={claro_style} text={claro_text} />
            <p></p>
            <center><a href="https://www.clarochile.cl/personas/servicios/servicios-hogar/television/boxtv/" target="_blank" rel="noreferrer"><img src={claro_box_tv} width="256" style={{borderRadius: "8px"}} alt="Box TV Claro Chile"/><br/>Box TV Claro Chile</a></center>
            <p></p>
            <Youtube video="https://www.youtube.com/embed/jEKyJogpzSg?si=ZmCGQhaRY9omvf4J"  title="Activa tus cuentas de plataformas de streaming | Claro Chile"/>
            <br/>
            <br/>
            <Jobliner logo={cordada_logo} style={cordada_style} text={cordada_text} />
            <p></p>
            <Youtube video="https://player.vimeo.com/video/1094844835?h=5c76274d03"  title="Cordada"/>
            <br/>
            <Jobliner logo={pixdragon_logo} style={pixdragon_style} text={elch_text} />
            <p></p>
            <center><a href="https://www.elch.app/" target="_blank" rel="noreferrer"><img src={elch_logo} width="256" alt="Energías Limpias Chile"/></a></center>
            <br/>
            </article>
            
            
        </div>
    );

    return(<div>{text_structure}</div>);
}